<script setup>
import { computed } from 'vue'

const props = defineProps({
    stage: {
        type: Number,
        required: false,
        default: 0
    }
})

</script>

<template>
    <div class="pointer-events-none relative">
        <div class="absolute w-48 left-0 bottom-0 right-0 -ml-24 text-center">
            <div
                class="relative transform transition-transform duration-1000 ease-out container"
                :class="'stage-' + stage"
            >
                <span
                    class="rocket relative"
                    :class="'stage-' + stage"
                >
                    <span
                        class="transform transition-transform -rotate-45"
                    >
                        <span class="rocket-body">
                            🚀
                        </span>
                    </span>
                    <span
                        class="absolute left-1/2 transform -translate-x-1/2"
                    >
                        <span
                            class="smoke-container"
                            :class="'stage-' + stage"
                        >
                            <span
                                class="smoke"
                                :class="'stage-' + stage"
                            >
                              💨
                            </span>
                        </span>
                    </span>
                </span>
            </div>
        </div>
    </div>
</template>

<style scoped>
span {
    font-size: 6rem;
    display: inline-block;
}

.rocket {
    display: inline-block;
    transition: all 3s ease-out;
}

.rocket.stage-0, .rocket.stage-1 {
    transform: translateY(110%);
    opacity: 0;
}

.rocket.stage-2, .rocket.stage-3 {
    transform: translateY(40%);
}

.rocket.stage-4 {
    transform: translateY(-150vh);
}

.rocket-body {
    transition: all 0.25s;
}

.rocket.stage-3 .rocket-body, .rocket.stage-4 .rocket-body {
    animation: shaking 250ms infinite;
}

.smoke-container.stage-4 {
    animation: smoking 250ms infinite;
}

.smoke {
    transform: translateY(50%) rotate(90deg);
    margin-left: 8%;
}


@keyframes shaking {
    0% { transform: rotate(-2deg) translateX(3%) translateY(3%); }
    25% { transform: rotate(1deg) translateX(1%) translateY(2%); }
    50% { transform: rotate(-2deg) translateX(2%) translateY(-1%); }
    75% { transform: rotate(2deg) translateX(-1%) translateY(2%); }
    100% { transform: rotate(-2deg) translateX(3%) translateY(3%); }
}

@keyframes smoking {
    0% { transform: scaleY(1) scaleX(1.15); }
    50% { transform: scaleY(1.25) scaleY(1); }
    100% { transform: scaleY(1) scaleX(1.15); }
}

</style>
